import BackgroundRings from "../components/BackgroundRings";
import {useEffect, useState} from "react";
import contact_api from "../api/public/contact"
import FAQS from "../models/FAQs";
import FAQContainer from "../components/FAQContainer";
import GenericDialog from "../components/GenericDialog";


const GetInTouch = () => {

    const [email, setEmail] = useState("")
    const [name, setName] = useState("")
    const [phoneNumber, setPhoneNumber] = useState("")
    const [subject, setSubject] = useState("")
    const [message, setMessage] = useState("")
    const [checkbox, setCheckbox] = useState(false)
    const [questions, setQuestions] = useState([])

    const [showResponsePopup, setShowResponsePopup] = useState(false)
    const [responsePopupTitle, setResponsePopupTitle] = useState("")
    const [responsePopupText, setResponsePopupText] = useState("")

    useEffect(() => {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'instant',
        })
    }, []);

    useEffect(() => {
        setQuestions(FAQS.SHORT_FAQS)
    },[])

    const sendMessage = (ev) => {
        if (!ev || !name || !email || !phoneNumber || !message || !checkbox) return;

        let response = contact_api.sendContactEmail(name, email, phoneNumber, subject, message)
        response.then(() => {
            setResponsePopupTitle("Message Sent")
            setResponsePopupText("The email has been sent successfully.")
            setShowResponsePopup(true)
        }).catch(() => {
            setResponsePopupTitle("Message Failed")
            setResponsePopupText("There has been an error trying to send the email. Please try again")
            setShowResponsePopup(true)
        })
    }

    const updateEmail = (ev) => {
        if (!ev) return;
        setEmail(ev.target.value)
    }
    const updateName = (ev) => {
        if (!ev) return;
        setName(ev.target.value)
    }
    const updatePhoneNumber = (ev) => {
        if (!ev) return;
        setPhoneNumber(ev.target.value)
    }
    const updateSubject = (ev) => {
        if (!ev) return;
        setSubject(ev.target.value)
    }
    const updateMessage = (ev) => {
        if (!ev) return;
        setMessage(ev.target.value)
    }
    const toggleCheckbox = (ev) => {
        if (!ev) return;
        setCheckbox(!checkbox)
    }

    const handleResponsePopup = () => {
        setShowResponsePopup(false)
        setResponsePopupTitle("")
        setResponsePopupText("")
    }

    return (
        <div className="learn-more-page-container get-in-touch">
            <BackgroundRings top={-370} right={-143}/>
            <div className="learn-more-page-title">Get in touch</div>
            <div className="learn-more-page-subtext">
                We are always happy to answer any questions that you might have regarding PERILL or the online
                Diagnostics for Teams platform and the related plans. Send us a message via the below form, and we’ll
                aim to get back to you within 48 hours.
            </div>
            <div className="get-in-touch-secondary-title">Firstly let’s see of our FAQ can help</div>
            <div className="privacy-policy-container home-contents">
                {questions && questions.map((section, sIdx) => (
                    <div key={sIdx} className="faq-section">
                        <div className="faq-section-heading">{section.heading}</div>
                        {section.items.map((question, qIdx) => (
                            <FAQContainer question={question} idx={qIdx} key={qIdx} />
                        ))}
                    </div>
                ))}
            </div>
            <div className="get-in-touch-more-help-container">
                <div className="get-in-touch-more-help-title">Still need more help? Contact us</div>
                <div className="get-in-touch-more-help-subtext">
                    If you have questions about the PERILL platform or do not know which plan to choose, leave your
                    request: we will be happy to answer all your questions.
                </div>
                <div className="get-in-touch-required-field">*Required field</div>
                <div className="get-in-touch-input-row">
                    <input type="text" placeholder="*Email" value={email} onChange={updateEmail}
                           className="get-in-touch-input"/>
                    <input type="text" placeholder="*Name" value={name} onChange={updateName}
                           className="get-in-touch-input"/>
                </div>
                <div className="get-in-touch-input-row">
                    <input type="text" placeholder="*Phone number" value={phoneNumber} onChange={updatePhoneNumber}
                           className="get-in-touch-input"/>
                    <input type="text" placeholder="Subject" value={subject} onChange={updateSubject}
                           className="get-in-touch-input"/>
                </div>
                <textarea placeholder="Your message here" value={message} onChange={updateMessage}
                          className="get-in-touch-input large-input"/>
                <div className="get-in-touch-radio-button-container">
                    <div className="get-in-touch-checkbox" onClick={toggleCheckbox}>
                        {checkbox ? <div className="get-in-touch-checkbox-centre"/> : null}
                    </div>
                    <div className="get-in-touch-radio-button-text">I agree the terms of data processing.</div>
                </div>
                <div className="home-page-button filled-button" onClick={sendMessage}>SEND MESSAGE</div>
                {showResponsePopup ?
                    <GenericDialog title={responsePopupTitle} text={responsePopupText}
                                   buttons={[{"text": "OK", "id": "1"}]} result={handleResponsePopup.bind(this)}
                    /> : null
                }
            </div>
        </div>
    )
}

export default GetInTouch